export const RegularScheduleVariationsRoutes = [
    {
        "url": "/regular-schedule-variations?week",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.regular-schedule-variations",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/regular-schedule-variations/regular-schedule-variations.downgrade.module");
                }
            }
        ],
        "views": {
            "body": {
                "component": 'regularScheduleVariationsContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "onEnter": ['brandServices', 'hUser', '$state', async (brandServices, hUser, $state) => {
                brandServices.checkAll(hUser.getEntryMode()['brand_id'], [brandServices.SERVICES.TEAM_SCHEDULING], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.TEAM_SCHEDULING]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }],
    }
];
//# sourceMappingURL=regular-schedule-variations.routes.js.map